module.exports = __webpack_public_path__ + "img/jcZI.f6259b33.png";